<template>
  <div class="text-sm font-body">
    <RouterView />
  </div>
</template>
